import { EventEmitter, OnDestroy } from '@angular/core';
import { MatAutocomplete } from '@angular/material/autocomplete';
import { MatInput } from '@angular/material/input';
import { Subject, of } from 'rxjs';
import { tap, takeUntil, map, switchMap, startWith, exhaustMap, concatMap } from 'rxjs/operators';
var InfinityScrollDirective = /** @class */ (function () {
    function InfinityScrollDirective(autoComplete) {
        var _this = this;
        this.autoComplete = autoComplete;
        this.thresholdPercent = .8;
        this._infinityScroll$ = new Subject();
        this.nextPage$ = new Subject();
        this.reduceOptions = [];
        this.currentPage = 0;
        this.size = 20;
        this.recordSearch = '';
        this.scrollRecordSearch = new EventEmitter();
        this._onDestroy = new Subject();
        this.autoComplete.opened.pipe(tap(function () {
            // Note: When autocomplete raises opened, panel is not yet created (by Overlay)
            // Note: The panel will be available on next tick
            // Note: The panel wil NOT open if there are no options to display
            setTimeout(function () {
                // Note: remove listner just for safety, in case the close event is skipped.
                _this.removeScrollEventListener();
                _this.autoComplete.panel.nativeElement
                    .addEventListener('scroll', _this.onScroll.bind(_this));
            });
        }), takeUntil(this._onDestroy)).subscribe();
        this.autoComplete.closed.pipe(tap(function () {
            _this.currentPage = 0;
            _this.reduceOptions = [];
            _this.nextPage$.next();
            _this.removeScrollEventListener();
        }), takeUntil(this._onDestroy)).subscribe();
    }
    Object.defineProperty(InfinityScrollDirective.prototype, "industryModel", {
        set: function (element) {
            this.initSubscription(element, this.options);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InfinityScrollDirective.prototype, "infinityModel", {
        get: function () {
            return this._infinityModel;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InfinityScrollDirective.prototype, "infinityScroll", {
        set: function (_options) {
            this.initSubscription(this.infinityModel, _options);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InfinityScrollDirective.prototype, "options", {
        get: function () {
            return this._options;
        },
        enumerable: true,
        configurable: true
    });
    InfinityScrollDirective.prototype.initSubscription = function (element, options) {
        var _this = this;
        this._infinityModel = element;
        this._options = options;
        if (element && options) {
            if (!this.isRecordSearch) {
                this.items = this._infinityModel.ngControl.valueChanges
                    .pipe(startWith(''), map(function (value) { return value ? value : ''; }), map(function (value) {
                    if (value &&
                        _this._options.filter(function (item) { return (item.value || item).toLowerCase().indexOf(value.toLowerCase()) >= 0; }).length > 0) {
                        return _this._options.filter(function (item) { return (item.value || item).toLowerCase().indexOf(value.toLowerCase()) >= 0; });
                    }
                    else {
                        return _this._options;
                    }
                }), tap(function () { return _this.currentPage = 0; }), tap(function () { return _this.reduceOptions = []; }), tap(function () { return _this.autoComplete._setScrollTop(0); }), switchMap(function (ops) {
                    return _this.nextPage$.pipe(startWith(_this.currentPage), exhaustMap(function () { return of(ops.slice(_this.currentPage * _this.size, _this.currentPage * _this.size + _this.size)); }), tap(function () { return _this.currentPage++; }), 
                    // scan((allProducts, newProducts) => allProducts.concat(newProducts), []),
                    map(function (newOptions) { return _this.reduceOptions = _this.reduceOptions.concat(newOptions); }));
                }));
                // scroll end of list
            }
            else {
                this.items = this._infinityModel.ngControl.valueChanges
                    .pipe(startWith(''), concatMap(function () {
                    var ops = _this._options;
                    if (element.value && (_this.recordSearch !== element.value)) {
                        _this.currentPage = 0;
                        _this.reduceOptions = [];
                        _this.autoComplete._setScrollTop(0);
                        _this.recordSearch = element.value;
                    }
                    return _this.nextPage$.pipe(startWith(_this.currentPage), exhaustMap(function () {
                        if ((ops.length > _this.reduceOptions.length) || (_this.reduceOptions.length === 0)) {
                            _this.reduceOptions = ops;
                            _this.currentPage = _this.currentPage + 1;
                        }
                        else {
                            _this.scrollRecordSearch.emit(_this.currentPage * _this.size);
                        }
                        return of(_this.reduceOptions);
                    }));
                }));
            }
        }
    };
    InfinityScrollDirective.prototype.removeScrollEventListener = function () {
        if (this.autoComplete.panel) {
            this.autoComplete.panel.nativeElement
                .removeEventListener('scroll', this.onScroll);
        }
    };
    InfinityScrollDirective.prototype.ngOnDestroy = function () {
        this._onDestroy.next();
        this._onDestroy.complete();
        this.nextPage$.complete();
        this._infinityScroll$.complete();
        this.removeScrollEventListener();
    };
    InfinityScrollDirective.prototype.onScroll = function (event) {
        if (this.thresholdPercent === undefined) {
            // this.scroll.next({ autoComplete: this.autoComplete, scrollEvent: event });
        }
        else {
            var threshold = this.thresholdPercent * 100 * event.target['scrollHeight'] / 100;
            var current = event.target['scrollTop'] + event.target['clientHeight'];
            if (current > threshold) {
                // this.scroll.next({ autoComplete: this.autoComplete, scrollEvent: event });
                this.nextPage$.next();
            }
        }
    };
    return InfinityScrollDirective;
}());
export { InfinityScrollDirective };
